
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Vimannagartomumbaicabs() {



    const cardData =
    {
        keyword: 'Viman Nagar to Mumbai Cabs',
        heading: 'Skyline Cabs: Viman Nagar to Mumbai Cabs',
        headingDescription: 'Skyline Cabs offers dependable and comfortable Viman Nagar to Mumbai Cabs for all your travel needs. Whether you are heading to Mumbai for business, a family trip, or an airport transfer, we ensure a safe, timely, and hassle-free journey. Our fleet includes well-maintained vehicles driven by professional chauffeurs, all available at affordable rates. Experience smooth travel with Skyline Cabs — book your Viman Nagar to Mumbai cab today and ride with confidence.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Viman Nagar to Mumbai Airport Cab",
      "description": "Skyline Cabs offers reliable and convenient cab services from Viman Nagar to Mumbai Airport. Our fleet includes a variety of vehicles, including Innova and Ertiga, ensuring a smooth and timely airport transfer."
    },
    {
      "name": "Wadgaon Sheri to Mumbai Cab Service",
      "description": "Skyline Cabs provides affordable and efficient taxi services from Wadgaon Sheri to Mumbai. Choose from a range of vehicles for a comfortable and hassle-free journey."
    },
    {
      "name": "Pune Airport to Mumbai Airport",
      "description": "Skyline Cabs offers airport transfer services from Pune Airport to Mumbai Airport. We provide a variety of vehicles like Innova and Ertiga for a comfortable and timely ride."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers seamless and reliable taxi services from Pune to Mumbai Airport. We ensure punctuality with a wide choice of vehicles like Innova, Ertiga, and more."
    },
    {
      "name": "Pune Airport to Mumbai International Airport",
      "description": "Book a convenient and comfortable taxi service from Pune Airport to Mumbai International Airport with Skyline Cabs. Our professional drivers ensure you arrive on time, with multiple vehicle options available."
    },
    {
      "name": "Lohegaon to Mumbai Airport Cab Service",
      "description": "Skyline Cabs provides reliable and affordable taxi services from Lohegaon to Mumbai Airport. Choose from a variety of vehicles for a smooth and comfortable ride."
    },
    {
      "name": "Dhanori to Mumbai Airport Cab",
      "description": "Skyline Cabs offers prompt and professional cab services from Dhanori to Mumbai Airport. Whether you're traveling for business or leisure, we provide a variety of vehicle options for your convenience."
    },
    {
      "name": "Vishrantwadi to Mumbai Cab Service",
      "description": "Skyline Cabs offers comfortable and reliable taxi services from Vishrantwadi to Mumbai. Our fleet includes vehicles like Innova and Ertiga for a smooth and enjoyable ride."
    },
    {
      "name": "Yerwada to Mumbai Airport Cab Service",
      "description": "Skyline Cabs offers professional and timely cab services from Yerwada to Mumbai Airport. Our vehicles include options like Innova and Ertiga for a comfortable journey."
    },
    {
      "name": "Cab Service in Viman Nagar",
      "description": "Skyline Cabs offers top-notch cab services in Viman Nagar, Pune. Whether you're traveling locally or to Mumbai, our fleet of well-maintained vehicles ensures a safe and comfortable ride."
    },
    {
      "name": "Pune Airport Cabs",
      "description": "Skyline Cabs provides dependable and affordable taxi services to and from Pune Airport. Choose from a range of vehicles, including luxury options like the Innova Crysta, for a comfortable ride."
    },
    {
      "name": "Innova Crysta Hire in Viman Nagar",
      "description": "Skyline Cabs offers Innova Crysta rentals in Viman Nagar, Pune. Ideal for family trips or group travel, the Innova Crysta provides ample space and comfort for a smooth journey."
    },
    {
      "name": "Ertiga Hire in Viman Nagar",
      "description": "Skyline Cabs provides Ertiga rentals in Viman Nagar, Pune. Perfect for small groups or families, the Ertiga offers comfort, style, and ample space for a pleasant trip to Mumbai."
    },
    {
      "name": "Pune Airport to Mumbai Airport Cab",
      "description": "Skyline Cabs offers smooth and efficient airport transfer services from Pune Airport to Mumbai Airport. Our fleet includes vehicles like the Innova and Ertiga for a comfortable and timely ride."
    },
    {
      "name": "Pune to Mumbai Airport Taxi Fare",
      "description": "Skyline Cabs provides competitive and transparent taxi fares for travel from Pune to Mumbai Airport. Enjoy a comfortable and stress-free ride with our well-maintained vehicles and professional drivers."
    },
    {
      "name": "Lohegaon to Mumbai Cab Service",
      "description": "Skyline Cabs offers convenient and affordable taxi services from Lohegaon to Mumbai. Choose from a variety of vehicles like Innova or Ertiga for a comfortable and reliable journey."
    },
    {
      "name": "Lohegaon to Mumbai Cab Service Price",
      "description": "Skyline Cabs offers transparent pricing for taxi services from Lohegaon to Mumbai. Our competitive rates ensure you receive value for your money while enjoying a smooth ride."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs provides reliable and affordable taxi services in Pune. Whether you're traveling locally or heading to Mumbai, we offer a variety of vehicles to ensure a comfortable and timely ride."
    },
    {
      "name": "Sedan Cabs on Rent in Viman Nagar",
      "description": "Skyline Cabs offers sedan rentals in Viman Nagar, Pune. Whether for a short trip or an outstation journey, our fleet of sedan cabs ensures a smooth and comfortable ride at affordable rates."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs offers a wide range of taxi services in Pune, from local trips to Mumbai airport transfers. We ensure a safe, timely, and comfortable ride with our fleet of vehicles."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers seamless taxi services from Pune to Mumbai Airport. We ensure comfort and punctuality with a wide range of vehicles, including luxury options like Innova and Ertiga."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs offers reliable and affordable cab services for travel between Pune and Mumbai. Whether you need a one-way trip or a round trip, we provide professional drivers and well-maintained vehicles."
    },
    {
      "name": "Cab Service in Viman Nagar Pune",
      "description": "Skyline Cabs provides professional and reliable taxi services in Viman Nagar, Pune. Our fleet of vehicles ensures you have a comfortable ride for any trip within the city or to Mumbai."
    },
    {
      "name": "Corporate Cab Services in Viman Nagar",
      "description": "Skyline Cabs offers efficient corporate cab services in Viman Nagar, Pune. Our fleet includes vehicles like Innova and Ertiga, ensuring comfortable and timely transport for business needs."
    }
  ],
  "tableData": [
    ["Viman Nagar to Mumbai Airport Cab", "Wadgaon Sheri to Mumbai Cab Service"],
    ["Pune Airport to Mumbai Airport", "Pune to Mumbai Airport Cab"],
    ["Pune Airport to Mumbai International Airport", "Lohegaon to Mumbai Airport Cab Service"],
    ["Dhanori to Mumbai Airport Cab", "Vishrantwadi to Mumbai Cab Service"],
    ["Yerwada to Mumbai Airport Cab Service", "Cab Service in Viman Nagar"],
    ["Pune Airport Cabs", "Innova Crysta Hire in Viman Nagar"],
    ["Ertiga Hire in Viman Nagar", "Pune Airport to Mumbai Airport Cab"],
    ["Pune to Mumbai Airport Taxi Fare", "Lohegaon to Mumbai Cab Service"],
    ["Lohegaon to Mumbai Cab Service Price", "Skyline Cabs Pune"],
    ["Sedan Cabs on Rent in Viman Nagar", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
    ["Cab Service in Viman Nagar Pune", "Corporate Cab Services in Viman Nagar"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Viman Nagar to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and punctual cab services from Viman Nagar to Mumbai. Whether you're traveling for business, leisure, or an airport transfer, we ensure that you arrive on time and without hassle. Count on us for dependable travel every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained vehicles, including sedans, SUVs, and luxury cars, ensures a comfortable and smooth ride from Viman Nagar to Mumbai. Enjoy spacious seating, air-conditioning, and a clean environment for a stress-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the best routes between Viman Nagar and Mumbai. They are well-trained, courteous, and background-checked, making sure your ride is safe, comfortable, and free of any worries."
    },
    {
        "WhyChooseheading": "Affordable Fares with Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive and transparent pricing for your Viman Nagar to Mumbai trip. There are no hidden charges, and you get clear fare estimates upfront, so you can travel with confidence and stay within your budget."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Time Travel",
        "WhyChoosedescription": "Whether you need an early morning ride or a late-night journey, Skyline Cabs is available 24/7. Our flexible service allows you to book a cab from Viman Nagar to Mumbai at your convenience, no matter the time of day."
    },
    {
        "WhyChooseheading": "Variety of Vehicles for All Group Sizes",
        "WhyChoosedescription": "No matter your travel group size, we have the perfect vehicle for your trip from Viman Nagar to Mumbai. Choose from our range of vehicles, including economical sedans, spacious SUVs, and premium cars for luxury travel."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking a cab from Viman Nagar to Mumbai is quick and easy with Skyline Cabs. Use our user-friendly mobile app or website to make your booking in just a few simple steps. Get instant confirmation and real-time tracking for a seamless experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are GPS-equipped for real-time tracking, and our drivers undergo extensive background checks. Travel securely and enjoy peace of mind during your journey from Viman Nagar to Mumbai."
    }
]
















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Viman Nagar to Mumbai with Skyline Cabs?',
            answer:
                'Booking your cab is simple! You can book directly through our website or mobile app. Just enter Viman Nagar as your pickup location, Mumbai as your destination, and choose the vehicle that suits your needs. Alternatively, you can call our support team for assistance.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Viman Nagar to Mumbai?',
            answer:
                'We offer a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose the one that best fits your comfort and space requirements.',
        },
        {
            id: 3,
            question: 'Is the fare from Viman Nagar to Mumbai fixed?',
            answer:
                'Yes, our pricing is fixed and transparent. The fare includes tolls, taxes, and driver charges. No hidden costs, and you’ll know the total fare upfront.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Viman Nagar to Mumbai?',
            answer:
                'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we will handle the rest.',
        },
        {
            id: 5,
            question: 'How long does the journey from Viman Nagar to Mumbai take?',
            answer:
                'The ride from Viman Nagar to Mumbai typically takes about 3.5 to 4 hours, depending on traffic conditions. We strive to ensure a timely and smooth journey for you.',
        },
        {
            id: 6,
            question: 'Are your drivers experienced with the Viman Nagar to Mumbai route?',
            answer:
                'Absolutely! Our drivers are well-trained, experienced, and familiar with the best routes to ensure a safe and comfortable ride from Viman Nagar to Mumbai.',
        },
        {
            id: 7,
            question: 'Can I book a cab for airport transfers from Viman Nagar to Mumbai?',
            answer:
                'Yes, we offer reliable airport transfer services. Whether you need a ride to or from Mumbai’s Domestic or International Airport, Skyline Cabs will ensure you arrive on time.',
        },
        {
            id: 8,
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer:
                'Yes, all our cabs are fully air-conditioned and thoroughly maintained for cleanliness and comfort. We prioritize hygiene and ensure a pleasant ride for you.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my booking after confirmation?',
            answer:
                'Yes, you can easily modify or cancel your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always ready to assist.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Viman Nagar to Mumbai trip?',
            answer:
                'Skyline Cabs offers competitive prices, a range of vehicle options, professional drivers, and timely service. Whether for business or leisure, we ensure a comfortable and stress-free ride.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Harish Mehta",
            rating: 5,
            review: "The ride from Viman Nagar to Mumbai was amazing. The driver was professional and the car was clean and comfortable. We reached Mumbai in no time, despite the usual traffic. Highly recommend Skyline Cabs!"
        },
        {
            name: "Miss. Aarti Deshmukh",
            rating: 4,
            review: "Very good experience! The driver was on time, and the car was very comfortable for our long ride from Viman Nagar to Mumbai. A little more legroom in the back seat would have been perfect, but overall, a great service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Viman Nagar to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/viman-nagar-to-mumbai-cab.jpg",
  "description": "Book Viman Nagar to Mumbai cab service with Skyline Cabs for safe, on-time, and comfortable travel. Choose AC sedans or SUVs, driven by professional chauffeurs, available 24/7 for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7816"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/viman-nagar-to-mumbai-cab-service"
  }
};


      
    
      

    return (
        <div>
<Helmet>
  <title>Viman Nagar to Mumbai Cab Service | 24/7 AC Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Viman Nagar to Mumbai cab service with Skyline Cabs for safe, on-time, and comfortable travel. Choose AC sedans or SUVs, driven by professional chauffeurs, available 24/7 for one-way or round trips." 
  />
  <meta 
    name="keywords" 
    content="Viman Nagar to Mumbai Cab Service, Cab from Viman Nagar to Mumbai, One-Way Taxi Viman Nagar to Mumbai, Round Trip Cab Viman Nagar to Mumbai, AC Cab Viman Nagar to Mumbai, SUV Taxi Viman Nagar to Mumbai, Affordable Cab Service Viman Nagar to Mumbai, Skyline Cabs Viman Nagar to Mumbai, Online Cab Booking Viman Nagar Mumbai, 24/7 Taxi Viman Nagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vimannagartomumbaicabs;